import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'training.trainingProgram';
    property = 'name';
    type: CellDisplay = CellDisplay.string;
}
